var $ = require('jquery');

$(function(){

  if(isPhone()) {
    $('span[data-action=call]').each(function(){
      var $ele;
      $ele = $(this);
      $dialNumber = $ele[0].innerText;
      $setNumber  = $dialNumber.replace(/-/g, "");
      $ele.wrap('<a href="tel:' + $setNumber + '"></a>');
    });

  } else {

    return;
  }
});